import SmallToggleButton from 'LuxKit/Button/SmallToggleButton'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import { take } from 'lib/array/arrayUtils'
import styled from 'styled-components'

import { MAX_PROPERTY_ROOM_RATES_TO_SHOW } from './propertyRoomConstants'
import PropertyRateOptionMerged from './PropertyRateOptionMerged'
import { CroSppCollapsedPackagesVariant } from './useCroSppCollapsedPackagesExperiment'
import type { GroupedPropertyRate } from './useGroupedPropertyRatesByRefundability'

const ShowMoreContent = styled(Pane)`
  border-top: 0 !important;
`

interface DesktopPackagesProps {
  groupedPropertyRates: Array<GroupedPropertyRate>
  initialRatesToShow: number
  lpcOffer?: App.HotelOffer
  packageCount: number
  propertyTimezone: string
  rateListId: string
  /** The property room's real id, distinct from `roomListId` (an analytics-only grouping id). */
  roomId: string
  roomListId: string
  roomPosition: number
  showLessOptionsText: string
  showMoreOptionsText: string
  showingMoreRates: boolean
  showMoreRates: () => void
}

function PropertyRoomDesktopPackageList(props: DesktopPackagesProps) {
  const {
    groupedPropertyRates,
    initialRatesToShow,
    lpcOffer,
    packageCount,
    propertyTimezone,
    rateListId,
    roomId,
    roomListId,
    roomPosition,
    showLessOptionsText,
    showMoreOptionsText,
    showingMoreRates,
    showMoreRates,
  } = props

  return <>
    {take(
      groupedPropertyRates || [],
      showingMoreRates ? MAX_PROPERTY_ROOM_RATES_TO_SHOW : initialRatesToShow,
    ).map((group) => {
      return (
        <PropertyRateOptionMerged
          key={group.groupingKey}
          lpcOffer={lpcOffer}
          rates={group.rates}
          defaultRateId={group.defaultRateId}
          roomId={roomId}
          roomListId={roomListId}
          roomPosition={roomPosition}
          rateListId={rateListId}
          propertyTimezone={propertyTimezone}
        />
      )
    })}
    {packageCount > initialRatesToShow && (
      <ShowMoreContent padding={12} border="light-foreground">
        <Group direction="horizontal" horizontalAlign="center">
          <SmallToggleButton
            on={showingMoreRates}
            onClick={showMoreRates}
            size="medium"
          >
            {showingMoreRates ? showLessOptionsText : showMoreOptionsText}
          </SmallToggleButton>
        </Group>
      </ShowMoreContent>
    )}
  </>
}

function PropertyRoomDesktopPackages(props: DesktopPackagesProps & {
  packagesExpanded: boolean
  packagesVariant: CroSppCollapsedPackagesVariant
}) {
  if (props.packagesVariant !== CroSppCollapsedPackagesVariant.control && !props.packagesExpanded) {
    return null
  }

  return <PropertyRoomDesktopPackageList {...props} />
}

export default PropertyRoomDesktopPackages
